import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "next-mdx-import-source-file";
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        h2: "h2",
        hr: "hr",
        h1: "h1",
        h4: "h4",
        a: "a"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
        children: [
            _jsx(_components.p, {
                children: 'Welcome to asadatik.dev! These terms and conditions ("Terms") govern your use of this personal website owned and operated by Asaduzzaman Atik ("I," "me," "my," or "mine"). By accessing and using asadatik.dev, you agree to comply with and be bound by these Terms. If you do not agree with any part of these Terms, please refrain from using the Website. 👍'
            }),
            "\n",
            _jsx(_components.h2, {
                children: "1. Personal Website Usage 🌐"
            }),
            "\n",
            _jsx(_components.p, {
                children: "asadatik.dev is intended for personal, non-commercial use only. You may access and view the content on this Website for your own informational purposes and to learn more about Asaduzzaman Atik, his life details, education, achievements, and CV."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "2. Intellectual Property Rights ©️"
            }),
            "\n",
            _jsx(_components.p, {
                children: "The content and materials available on asadatik.dev, including but not limited to text, graphics, logos, images, videos, and CV, are protected by applicable copyright and other intellectual property laws. All rights are reserved."
            }),
            "\n",
            _jsx(_components.p, {
                children: "You may not reproduce, distribute, modify, create derivative works of, publicly display, or use any content from asadatik.dev without my explicit written permission."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "3. Third-Party Websites 🌐"
            }),
            "\n",
            _jsx(_components.p, {
                children: "asadatik.dev may contain links to third-party websites. These links are provided for your convenience, and I have no control over the content, policies, or practices of these external sites. You access and use third-party websites at your own risk. Please review the privacy policies and terms of use of any third-party sites you visit."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "4. Website Availability 🌐"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I strive to maintain the availability and functionality of asadatik.dev. However, I do not guarantee continuous, uninterrupted, or error-free access to the Website. I reserve the right to modify, suspend, or discontinue any part or all of the Website at any time without prior notice."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "5. Limitation of Liability 🚫"
            }),
            "\n",
            _jsx(_components.p, {
                children: "To the maximum extent permitted by law, I shall not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages arising from your use of asadatik.dev or any content therein. This includes, but is not limited to, damages for loss of profits, goodwill, data, or other intangible losses, even if I have been advised of the possibility of such damages."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "6. Contact 📞"
            }),
            "\n",
            _jsx(_components.p, {
                children: "For any inquiries or questions regarding these Terms or any issues related to asadatik.dev, please contact me at asadatik.me@gmail.com."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "7. Changes to the Terms and Conditions 🔄"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I reserve the right to update or modify these Terms at any time without prior notice. Any changes will be effective immediately upon posting the updated Terms on asadatik.dev. Your continued use of the Website after any such changes constitutes your acceptance of the modified Terms."
            }),
            "\n",
            _jsx(_components.hr, {}),
            "\n",
            _jsx(_components.h1, {
                children: "Privacy Policy 🕵️‍♂️"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Please refer to the Privacy Policy section below for information on how your personal data is collected, used, and protected on asadatik.dev."
            }),
            "\n",
            _jsx(_components.hr, {}),
            "\n",
            _jsx(_components.h4, {
                children: "Privacy Policy"
            }),
            "\n",
            _jsx(_components.p, {
                children: _jsx(_components.a, {
                    href: "/policies/privacy-policy",
                    children: "Click here to view the Privacy Policy"
                })
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
